import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Grid, Typography } from "@mui/material";
import { useLocation } from 'react-router-dom';
import React from "react";
import { Config } from "../Config";
import { V5Origin } from "../services/Types";

const useStyles = makeStyles({
  welcomeText: {
    fontFamily: "SF Pro Display",
    color: "#008094",    
    fontSize: "20px",
    textAlign: "left",
    paddingLeft: "24px",    
    height: "17px",
    lineHeight: "16.71px"
  },
  welcomeBox: {    
    color: "#008094",
    marginTop: "16px",    
    height: "64px",
    "& h1": {
      lineHeight: "64px",
    }
  },  
  icon: {
    fontSize: "1rem",
  }
});

function Header() {
  const classes = useStyles();
    
  let query = useQuery();

  let previousPageUrl = "";
  let previousPageUrlText = "";
  const origin = query.get("origin_client") ? query.get("origin_client") : undefined;  
  
  if(origin === V5Origin.SERVICE)
  {
    previousPageUrl = Config.v5.serviceSite;
    previousPageUrlText="Service site";
  }
  
  if(origin === V5Origin.EMPLOYER)
  {
    previousPageUrl = Config.v5.employerSite;
    previousPageUrlText="Back to Contacts";
  }
    
  return (         
    <>
      <Box className={classes.welcomeBox}>      
        <Box className={classes.welcomeText}>
        <Grid container rowSpacing={1}>
          <Grid item><NavigateBeforeIcon></NavigateBeforeIcon> </Grid>
          <Grid item><Typography>
                      <a href={previousPageUrl}>{previousPageUrlText}</a>                      
                     </Typography>
          </Grid>
        </Grid>
        </Box>
      </Box>
    </>
  );
}

export default Header;

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
